import React from 'react';
import {
  Grid, Typography, TextField,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useFormikContext } from 'formik';
import _ from 'lodash';
import { NumericFormat } from 'react-number-format';
import { WIZARD_QUESTIONS, FILING_STATUS } from '../../../../constants';

const ThirdStep = () => {
  const largeScreen = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const { setFieldValue, errors, values } = useFormikContext();
  const [socialSecurityStartAge, setSocialSecurityStartAge] = React.useState(_.get(values, 'benefitEstimator.socialSecurityStartAge'));
  const [spouseSocialSecurityStartAge, setSpouseSocialSecurityStartAge] = React.useState(_.get(values, 'benefitEstimator.spouseSocialSecurityStartAge'));
  const filingStatus = _.get(values, 'benefitEstimator.filingStatus');

  const handlerSocialSecurityStartAge = (value) => {
    setSocialSecurityStartAge(value);
    setFieldValue('benefitEstimator.socialSecurityStartAge', value);
  };

  const handlerSpouseSocialSecurityStartAge = (value) => {
    setSpouseSocialSecurityStartAge(value);
    setFieldValue('benefitEstimator.spouseSocialSecurityStartAge', value);
  };

  return (
    <Grid container spacing={2} direction='column'>
      <Typography className='steps-wizard-steps question-text'>
        {
          filingStatus === FILING_STATUS.SINGLE
            ? WIZARD_QUESTIONS.STARTAGE.SINGLE
            : WIZARD_QUESTIONS.STARTAGE.JOINT
        }
      </Typography>
      <Typography className='steps-wizard-steps question-desc'>
        {
          filingStatus === FILING_STATUS.SINGLE
            ? WIZARD_QUESTIONS.SSBENEFITSTARTAGE.SINGLE
            : WIZARD_QUESTIONS.SSBENEFITSTARTAGE.JOINT
        }
      </Typography>
      <Grid container direction={largeScreen ? 'row' : 'column'} alignItems='flex-start' justifyContent={largeScreen ? 'flex-start' : 'center'} className={!largeScreen ? 'wizard-step-input-container' : ''}>
        {
          filingStatus === FILING_STATUS.SINGLE
            ? (
              <NumericFormat
                className='steps-wizard-steps answer-input answer-input-mt answer-input-small'
                name='socialSecurityStartAge'
                value={socialSecurityStartAge}
                customInput={TextField}
                inputProps={{
                  maxLength: 2,
                }}
                error={_.has(errors, 'benefitEstimator.socialSecurityStartAge')}
                helperText={_.get(errors, 'benefitEstimator.socialSecurityStartAge')}
                required
                onValueChange={(numberFormatValues) => {
                  const { value } = numberFormatValues;
                  handlerSocialSecurityStartAge(value);
                }}
              />
            )
            : (
              <>
                <Grid item>
                  <Typography className='steps-wizard-steps answer-text'>
                    Your Start Age
                  </Typography>
                  <NumericFormat
                    className={`steps-wizard-steps answer-input ${largeScreen ? 'answer-input-mr' : undefined} answer-input-small`}
                    name='socialSecurityStartAge'
                    value={socialSecurityStartAge}
                    customInput={TextField}
                    inputProps={{
                      maxLength: 2,
                    }}
                    error={_.has(errors, 'benefitEstimator.socialSecurityStartAge')}
                    helperText={_.get(errors, 'benefitEstimator.socialSecurityStartAge')}
                    required
                    onValueChange={(numberFormatValues) => {
                      const { value } = numberFormatValues;
                      handlerSocialSecurityStartAge(value);
                    }}
                  />
                </Grid>
                <Grid item>
                  <Typography className='steps-wizard-steps answer-text'>
                    Your Spouse&apos;s Start Age
                  </Typography>
                  <NumericFormat
                    className={`steps-wizard-steps answer-input ${largeScreen ? 'answer-input-mr' : undefined} answer-input-small error-message-lg`}
                    name='spouseSocialSecurityStartAge'
                    value={spouseSocialSecurityStartAge}
                    customInput={TextField}
                    inputProps={{
                      maxLength: 2,
                    }}
                    error={_.has(errors, 'benefitEstimator.spouseSocialSecurityStartAge')}
                    helperText={_.get(errors, 'benefitEstimator.spouseSocialSecurityStartAge')}
                    required
                    onValueChange={(numberFormatValues) => {
                      const { value } = numberFormatValues;
                      handlerSpouseSocialSecurityStartAge(value);
                    }}
                  />
                </Grid>
              </>
            )
        }
      </Grid>
    </Grid>
  );
};

export default ThirdStep;
